/**
 * Catalog page
 * @param {$stateProvider} $stateProvider Let us define new states
 */
module.config(['$stateProvider', 'urls', function ($stateProvider, urls) {
    'use strict';
    $stateProvider.state('catalog', {
        url: '/' + urls.catalog.fr + '?{success}', // TODO : when multilang, change this to something dynamic
        controller: ['$scope', '$rootScope', '$filter', 'headermanager', '$document', 'drupal', 'lodash', '$stateParams',
            function ($scope, $rootScope, $filter, $headermanager, $document, $drupal, lodash, $stateParams) {
                $scope.title = $filter('translate')('catalog.title');

                $scope.config = $rootScope.config.site;

                if ($stateParams.success) {
                    $scope.success = true;
                }

                // build  breadcrumb
                $scope.breadcrumb = [
                    { label: $filter('translate')('home'), state: 'homepage' },
                    { label: $filter('translate')('catalog.titleShort') }
                ];

                // customize header
                $headermanager.customize({
                    filled: true
                });

                // form data (model)
                $scope.catalogForm = {
                    pending: false
                };
                $scope.civilityLabels = [
                    { text: $filter('translate')('form.male'), value: 'M.' },
                    { text: $filter('translate')('form.female'), value: 'Mme' }
                ];
                $scope.methodsLabels = [
                    { text: $filter('translate')('form.choiceCatalogDownload'), value: false },
                    { text: $filter('translate')('form.choiceCatalogMail'), value: true }
                ];

                // form data (validators)
                $scope.form = {
                    civility: $scope.civilityLabels[0].value,
                    method: $scope.methodsLabels[0].value,
                    catalog_junior: false,
                    catalog_adulte: false,
                    newsletter_official: false,
                    newsletter_commercial: false
                };
                $scope.hasErrors = false;

                $scope.scrolltoForm = function () {
                    var element = angular.element(document.getElementById('catalogForm'));
                    $document.scrollToElement(element, 30, 250);
                };

                // TODO: unmock if API allows to registrer catalog subscription
                $scope.subscribeCatalog = function () {
                    if ($scope.catalogForm.$valid) {
                        $scope.catalogForm.pending = true;
                        $scope.hasErrors = false;
                        $drupal.subscribeCatalog(lodash.pick(angular.copy($scope.form), ['civility', 'lastname', 'firstname', 'email', 'street', 'postal_code', 'city', 'country', 'newsletter_official', 'newsletter_commercial', 'method', 'catalog_junior', 'catalog_adulte'])).then(function (result) {
                            if (result.status === 'OK') {
                                $scope.success = true;
                            } else {
                                throw 'Error';
                            }
                        }).catch(function (error) {
                            console.log('Error:subscribe catalog', error);
                        }).finally(function () {
                            $scope.catalogForm.pending = false;
                            $scope.scrolltoForm();
                        });
                    } else {
                        $scope.scrolltoForm();
                    }
                };

                // form watcher for ggPlaces
                $scope.$watchCollection('form.search_address', function (newValue) {
                    var gmodel = newValue;
                    var result = {};
                    var i;
                    var l;

                    if (gmodel && gmodel.address_components) {

                        /* google format parser */
                        l = gmodel.address_components.length;
                        for (i = 0; i < l; i += 1) {
                            result[gmodel.address_components[i].types[0]] = gmodel.address_components[i].long_name;
                        }

                        /* set result */
                        $scope.form.street = result.street_number + ' ' + result.route;
                        $scope.form.city = result.locality;
                        $scope.form.postal_code = parseInt(result.postal_code);
                        $scope.form.country = result.country;
                    }
                });
            }],
        templateUrl: 'src/views/catalog/catalog.html'
    });
}]);
